export default __webpack_public_path__ + "static/media/02.9932b4d1.jpg";